module.exports = __webpack_public_path__ + "static/media/014_iOS - 16 - PHARMACY.109a3a68.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/kp/014_iOS - 16 - PHARMACY.png
// module id = 511
// module chunks = 0